export default __webpack_public_path__ + "static/media/loaderBlends.8bafdb85.gif";